import {
  red, pink, purple, deepPurple, indigo, blue, lightBlue, cyan, teal,
  green, lightGreen, lime, yellow, amber, orange, deepOrange,
} from '@material-ui/core/colors';

export const PRIMARY_COLOR = blue;
export const TRANSITIONS_TIME = 400;
export const DEFAULT_PALETTE = [
  red, pink, purple, deepPurple, indigo, blue, lightBlue, cyan, teal,
  green, lightGreen, lime, yellow, amber, orange, deepOrange,
];

export const XS_CELL_WIDTH = 50;
export const SMALL_CELL_WIDTH = 65;
export const CELL_WIDTH = 100;

export const XS_LAYOUT_WIDTH = 500;
export const SMALL_LAYOUT_WIDTH = 700;

export const SMALL_LAYOUT_MEDIA_QUERY = `@media (max-width: ${XS_LAYOUT_WIDTH}px)`;
export const LAYOUT_MEDIA_QUERY = `@media (max-width: ${SMALL_LAYOUT_WIDTH}px)`;
